// @flow
export { default } from './OrderDetailTemplate';



// WEBPACK FOOTER //
// ./src/components/order/OrderDetailTemplate/index.js